import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {Child, Group} from "../../../../../types/interfaces";
import {MyGreenCountry} from "../../../../../services/mygreencountry/my-greencountry";
import {group} from "@angular/animations";
import {
    EXCLUDED_GROUP_TYPES_FOR_PRACTICING,
    GROUP_TYPE_BOOK_PLUS_ACCESS,
    GROUP_TYPE_CAMP,
    GROUP_TYPE_ZNO
} from "../../../../constants";

type MessageType = 'telegram' | 'practicing' | 'studentsMeeting'| 'meeting';

@Component({
    selector: 'app-telegram',
    templateUrl: './telegram.component.html',
    styleUrls: ['./telegram.component.scss'],
})
export class TelegramComponent implements OnInit {

    @Input() groups: Group[] | undefined = undefined;
    @Input() type: MessageType = 'telegram';
    @Input() open: boolean = false;
    public student: Child | null;

    constructor(private modalCtrl: ModalController, public myGcService: MyGreenCountry,) {
    }

    ngOnInit() {

        if (this.type === 'practicing' && this.groups) {

            console.log(this.groups)

            this.groups = this.groups.filter(group =>
                !EXCLUDED_GROUP_TYPES_FOR_PRACTICING.has(group.typeCourse)
                && group.time !== "isPast");
        }

        if (this.type === 'studentsMeeting' && this.groups) {

            this.groups = this.groups.filter(group =>
                group.typeCourse != GROUP_TYPE_CAMP &&  group.typeCourse != GROUP_TYPE_BOOK_PLUS_ACCESS
                && group.time !== "isPast");
        }

    }


    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    openUrl(url: string|undefined) {

        if (url){
            this.myGcService.openUrl(url)
        }

    }

    protected readonly group = group;
}
